import {List, Map, Record} from 'immutable';
import {memoize} from 'lib/memoizer';
import type {SubjectModel} from 'resources/Subject/Subject.model';

export class GuideLevel extends Record({
   
  description: '',
  free: '',
  id: '',
  level: '',
  meta: Map(),
  name: '',
  objective_data: List(),
  position: 0,
  question_sets: List(),
  subject: Map(),
  subtopics: Map(),
  tags: List(),
  theme_img: '',
  themes: Map(),
  topics: Map(),
  url_slug: ''
   
}) {
  cache: ReturnType<typeof memoize>;

  constructor(data: Map<unknown, unknown>) {
    super(data);
    this.cache = memoize();
  }

  getId(): string {
    return this.get('id');
  }

  isFree(): boolean {
    return this.get('free');
  }

  getLevel(): string {
    return this.get('level');
  }

  getPosition(): number {
    return this.get('position');
  }

  getThemeImg(): string {
    return this.get('theme_img');
  }

  getDescription(): string {
    return this.get('description');
  }

  getName(): string {
    return this.get('name');
  }

  getUrlSlug(): string {
    return this.get('url_slug');
  }

  getQuestions(): List<Map<unknown, unknown>> {
    return this.get('question_sets');
  }

  getSubject(): SubjectModel {
    return this.get('subject');
  }

  getTopics(): List<GuideLevel> {
    return this.get('topics');
  }

  getSubtopics(): List<GuideLevel> {
    return this.get('subtopics');
  }

  getSortedTopics(): List<GuideLevel> {
    return this.cache('topics', () => this.get('topics').sortBy((topic) => topic.getPosition()));
  }

  getSortedSubtopics(): List<GuideLevel> {
    return this.cache('subtopics', () =>
      this.get('subtopics').sortBy((subtopic) => subtopic.getPosition())
    );
  }
}
